import {getEnv} from '../../common/env/env';
import {CharacterVo} from '../../common/shared/api/nicolas/vo/CharacterVo.interface';
import {getKageUrl} from '../../common/shared/utils/getKageUrl';
import {Character} from '../generated/types';

export function createCharacter({
  thumbnail,
  name,
  description,
}: CharacterVo): Character {
  return {
    thumbnail:
      thumbnail === undefined
        ? ''
        : thumbnail?.startsWith('http')
          ? thumbnail
          : getKageUrl({
              kageUrlPrefix: getEnv().kageUrlPrefix,
              kageId: thumbnail,
              resolution: 'th3',
            }),
    name,
    description,
  };
}
